/**
 * MARCOS ALPHA — Premium Streetwear Storefront
 * Custom JS: Advanced 3D scrolling, header behavior, layered parallax
 */

(function () {
  'use strict';

  /* ---------- Preloader ---------- */
  function initPreloader() {
    const preloader = document.querySelector('.marcos-preloader');
    if (!(preloader instanceof HTMLElement)) return;

    function dismissPreloader() {
      if (!preloader || preloader.classList.contains('is-zooming')) return;
      // Trigger zoom-out
      preloader.classList.add('is-zooming');
      // Initialize header after zoom starts
      const header = document.querySelector('.marcos-header');
      if (header instanceof HTMLElement) {
        setTimeout(() => header.classList.add('is-initialized'), 500);
      }
      // Clean up after transition
      preloader.addEventListener('transitionend', function handler() {
        if (preloader instanceof HTMLElement) {
          preloader.style.display = 'none';
        }
        preloader.removeEventListener('transitionend', handler);
      });
    }

    window.addEventListener('load', function () {
      // Let the content/animation breathe then dismiss
      setTimeout(dismissPreloader, 1500);
    });

    // Safety timeout in case load event takes too long
    setTimeout(function () {
      if (preloader && !preloader.classList.contains('is-zooming')) {
        dismissPreloader();
      }
    }, 5000);
  }

  /* ---------- Advanced Header Behavior ---------- */
  function initHeader() {
    const header = document.querySelector('.marcos-header');
    const announcement = document.querySelector('.marcos-announcement');
    if (!(header instanceof HTMLElement)) return;

    let lastScroll = 0;
    const threshold = 100;
    let headerHidden = false;

    function updateHeader() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Skip hide/show if menu is open
      if (header instanceof HTMLElement && header.classList.contains('is-menu-open')) return;

      // Transparent vs Solid
      if (header instanceof HTMLElement) {
        if (currentScroll > 50) {
          header.classList.remove('marcos-header--transparent');
          header.classList.add('marcos-header--solid');
        } else {
          header.classList.add('marcos-header--transparent');
          header.classList.remove('marcos-header--solid');
        }
      }

      // Hide/Show on Scroll (Only apply to mobile/tablet)
      if (header instanceof HTMLElement) {
        if (currentScroll > threshold && window.innerWidth <= 1024) {
          if (currentScroll > lastScroll && !headerHidden) {
            // Scrolling down - Hide
            header.style.transform = 'translateY(-100%)';
            headerHidden = true;
          } else if (currentScroll < lastScroll && headerHidden) {
            // Scrolling up - Show
            header.style.transform = 'translateY(0)';
            headerHidden = false;
          }
        } else {
          header.style.transform = 'translateY(0)';
          headerHidden = false;
        }

        // Announcement placement
        if (announcement instanceof HTMLElement && currentScroll <= announcement.offsetHeight) {
           header.style.marginTop = Math.max(0, announcement.offsetHeight - currentScroll) + 'px';
        } else {
           header.style.marginTop = '0';
        }
      }

      lastScroll = currentScroll;
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ---------- Mobile Menu with Staggered Links ---------- */
  function initMobileMenu() {
    const toggle = document.querySelector('.marcos-header__menu-toggle');
    const menu = document.querySelector('.marcos-mobile-menu');
    const close = document.querySelector('.marcos-mobile-menu__close');
    const header = document.querySelector('.marcos-header');

    if (!(toggle instanceof HTMLElement) || !(menu instanceof HTMLElement)) return;

    toggle.addEventListener('click', function () {
      const isOpen = menu instanceof HTMLElement && menu.classList.contains('is-active');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    function openMenu() {
      if (menu instanceof HTMLElement) menu.classList.add('is-active');
      if (header instanceof HTMLElement) header.classList.add('is-menu-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      if (menu instanceof HTMLElement) menu.classList.remove('is-active');
      if (header instanceof HTMLElement) header.classList.remove('is-menu-open');
      document.body.style.overflow = '';
    }

    if (close instanceof HTMLElement) {
      close.addEventListener('click', closeMenu);
    }

    if (menu instanceof HTMLElement) {
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }
  }

  /* ---------- Scroll Reveals — handles both legacy .ma-reveal and new .mh-fade ---------- */
  function initScrollReveal() {
    const reveals = document.querySelectorAll('.ma-reveal, .ma-reveal-3d, .mh-fade');
    if (!reveals.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Subtle Hero Parallax (image only, no text transforms) ---------- */
  function initHeroParallax() {
    const heroImg = document.querySelector('.mh__bg-img');
    if (!(heroImg instanceof HTMLElement)) return;

    // Only run on devices that can hover (i.e., desktops)
    if (!window.matchMedia('(hover: hover)').matches) return;

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      window.requestAnimationFrame(function () {
        const scrollY = window.pageYOffset;
        if (scrollY < window.innerHeight) {
          // Gentle 10% parallax — image moves up slowly as you scroll
          heroImg.style.transform = `translateY(${scrollY * 0.1}px) scale(1.035)`;
        }
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  function init() {
    initPreloader();
    initHeader();
    initMobileMenu();
    initScrollReveal();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
